import { useQuery } from "@tanstack/react-query";

import { listEmailTemplates } from "./api";
import type { EmailTemplatesResponse } from "./types";

export const EmailTemplatesKeys = {
  all: ["email-templates"] as const,
  list: () => ["email-templates", "list"] as const,
};

export function useEmailTemplates() {
  return useQuery<EmailTemplatesResponse>({
    queryKey: EmailTemplatesKeys.list(),
    queryFn: () => listEmailTemplates(),
    staleTime: 60_000,
    gcTime: 10 * 60_000,
  });
}
